import React from 'react';
import './style.scss';
import { DefaultIcon, Search as SearchIcon } from '../../../atoms/icons/index';

interface Props {
  icon?: React.ReactElement<DefaultIcon>|undefined;
  placeholder?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement> | undefined;
  value?:string | undefined;
  disabled?: boolean;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement> | undefined
}

const Search:React.FC<Props> = (props) => {
  const {
    icon = <SearchIcon width={16} />,
    placeholder = 'Search something',
    onChange, value, disabled = false,
    onKeyDown,
  } = props;
  return (
    <div className="search-container">
      <button className="search-icon border-0 bg-transparent" type="submit">
        <div className="me-2">{icon}</div>
      </button>
      <input
        className="fz-14 search-input flex-grow-1"
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        onKeyDown={onKeyDown}
      />
    </div>
  );
};

export default Search;
